import React, { memo } from 'react';
const ImportsIcon = _ref => {
  let {
    color = '#335B70'
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 16h16a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2zm3.8-2.4a.998.998 0 0 1-1.588.016 1.01 1.01 0 0 1-.09-.08l-2.83-2.829a1 1 0 0 1 1.415-1.414L3 10.586V1a1 1 0 1 1 2 0v9.578l1.286-1.285A1 1 0 1 1 7.7 10.707L4.87 13.536a1.012 1.012 0 0 1-.072.065zM14.8.4a.998.998 0 0 0-1.588-.016 1.01 1.01 0 0 0-.09.08l-2.83 2.829a1 1 0 0 0 1.415 1.414L13 3.414V13a1 1 0 0 0 2 0V3.422l1.286 1.285A1 1 0 0 0 17.7 3.293L14.87.464A1.012 1.012 0 0 0 14.8.4z",
    fill: color,
    fillRule: "evenodd"
  }));
};
export default /*#__PURE__*/memo(ImportsIcon);